import styled from "styled-components";

import {
  colors,
  assets,
  MOBILE_BREAKPOINT,
  TABLET_BREAKPOINT,
  LAPTOP_BREAKPOINT,
  SMALL_LAPTOP_BREAKPOINT,
  colorsRGB,
  DEFAULT_FONT,
  fontSizes,
  isAnathoth,
} from "@util/constants";
import { Container } from "@util/standard";
import { Link } from "@global";

export const AbsoluteWrapper = styled.div<{
  top?: number;
  height?: number;
  isHovered?: boolean;
  isScrolled?: boolean;
  zIndex?: number;
}>`
  display: flex;
  position: absolute;
  left: -37px;
  right: -37px;
  top: 100%;
  height: ${props => props.height ?? 400}px;
  background-color: var(--theme-site-bg);
  top: ${isAnathoth ? "85px" : "60px"};

  ${({ zIndex }) => zIndex && `z-index: ${zIndex};`}
`;

export const DropDownWrapper = styled(Container)`
  width: 100%;
  margin: 40px 0 60px;
`;

export const SubLinkContainer = styled(Container)<{ isLast: boolean }>`
  flex-direction: row;
  padding: 0 0 0 46px;
  align-items: flex-start;
  text-align: left;
  ${({ isLast }) =>
    !isLast && `border-right: 1px solid var(--theme-primary-color);`}
`;

export const HeadWrapper = styled(Container)<{
  hovered?: boolean;
  isDark?: boolean;
}>`
  width: 100%;
  position: fixed;
  top: var(--announcement-bar-height, 0px);
  background-color: var(--theme-site-bg);
  min-height: 79px;
  z-index: 22;
  transition: top 300ms ease-in-out;
`;

export const HeaderContainer = styled(Container)`
  width: 100%;
  margin: 13px 37px;
  position: relative;

  .header-link {
    font-weight: 600;
    font-size: ${fontSizes.p.alternate}px;
  }

  @media only screen and (max-width: ${LAPTOP_BREAKPOINT}px) {
    display: none;
  }
`;

export const TopContainer = styled(Container)<{ hide?: boolean }>`
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${props => (props.hide ? ` display: none;` : ` display: flex;`)}
`;

export const SectionContainer = styled(Container)<{
  hasBorderBottom?: boolean;
  hovered?: boolean;
  isDark?: boolean;
  hasScrolled?: boolean;
  hideOnScroll?: boolean;
}>`
  width: 100%;
  align-items: center;
  gap: 30px;
  ${({ hasBorderBottom }) =>
    hasBorderBottom && `border-bottom: 1.5px solid ${colorsRGB.white(0.2)};`}

  ${({ isDark }) =>
    isDark && `border-bottom: 1.5px solid ${colors.barkersDarkGray};`}

  ${({ hasScrolled }) =>
    hasScrolled && `border-bottom: 1.5px solid ${colors.barkersDarkGray};`}

  ${({ hideOnScroll, hasScrolled }) =>
    hideOnScroll && hasScrolled && `display: none;`}

  ${({ hovered }) => hovered && `border-bottom: none;`}
`;

export const DesktopLinksContainer = styled(Container)`
  margin: 0;
  width: auto;
  align-items: center;

  .link {
    padding-left: 40px;
  }

  @media only screen and (max-width: ${TABLET_BREAKPOINT}px) {
    display: none;
  }
`;

export const MobileContainer = styled(Container)`
  display: none;
  margin: 30px;
  width: 100%;
  justify-content: space-between;

  @media only screen and (max-width: ${LAPTOP_BREAKPOINT}px) {
    margin: 10px 30px;
    display: flex;
    #EZDrawer__container {
      overflow: auto;
    }
    .Accordion {
      margin: 0 0 20px;
    }
    .Accordion__header {
      font-size: 14px;
      line-height: 1.6;
      font-weight: 600;
      &:after {
        width: 10px;
        height: 10px;
      }
    }
    .Accordion__body {
      padding: 0 0 0 15px;
      > div {
        margin: 0;
        grid-row-gap: 0;
      }
      a {
        display: inline-block;
        padding: 5px 0;
      }
      &.Accordion__body p {
        font-weight: 400;
      }
    }
  }
  @media only screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    margin: 20px 30px;
  }
`;

export const MobileExternalLink = styled(Link)<{}>`
  padding: 10px 8px;
  margin: 10px;
  background-color: ${colorsRGB.merlin(0.08)};
  width: fit-content;
  color: var(--theme-primary-color);

  @media only screen and (max-width: ${SMALL_LAPTOP_BREAKPOINT}px) {
    font-size: 14px;
  }
`;

/*
 *
 * Hero Styles
 *
 */
export const VideoWrapper = styled.div<{ width?: string }>`
  position: relative;
  height: 100%;

  width: ${props => props.width ?? "0px"};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  pointer-events: none;
`;

export const VideoIFrame = styled.iframe<{ width?: string; height?: string }>`
  width: ${props => props.width ?? "100vw"};
  height: ${props => props.height ?? "56.25vw"};
  min-height: ${props => props.height ?? "100vh"};
  min-width: 177.77vh;
  border: none;
  position: absolute;
`;

export const CarouselLeftArrow = styled.div<{
  position?: string;
  left?: string;
  right?: string;
  hideOnMobile?: boolean;
  opacity?: number;
  rightArrow?: boolean;
  isAnathoth?: boolean;
}>`
  background-color: ${isAnathoth
    ? "var(--theme-button-color)"
    : colorsRGB.white(0.8)} !important;
  border-radius: 100px;
  position: ${props => props.position ?? "relative"};
  z-index: 10;
  width: 52px !important;
  height: 52px !important;
  ${({ left }) => left && `left: ${left};`}
  ${({ right }) => right && `right: ${right};`}
  ${({ opacity }) => opacity && `opacity: ${opacity};`}


  display: flex !important;
  justify-content: center;
  align-items: center;
  &:before {
    display: none;
  }
  img {
    width: 20px;
    height: 20px;
    ${({ isAnathoth }) => isAnathoth && `filter: invert(1)`}
  }

  .slick-arrow {
    background-color: var(--theme-primary-color);
  }
  &:hover {
    background: ${colorsRGB.white(0.7)};
  }
  @media only screen and (max-width: ${TABLET_BREAKPOINT}px) {
    width: 35px;
    height: 35px;
    img {
      width: 14px;
      height: 14px;
    }
  }
  @media only screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    ${({ hideOnMobile }) => hideOnMobile && `display: none !important;`}

    width: 25px;
    height: 25px;
    img {
      width: 9px;
      height: 9px;
    }
  }

  ${({ rightArrow }) =>
    rightArrow &&
    `img {
    transform: rotate(180deg);
    margin-left: 0;
  }`}
`;

export const RelatedCollectionContainer = styled(Container)`
  .slick-arrow {
    z-index: 2;
    position: absolute;
    &.slick-disabled {
      display: none !important;
    }
  }
  .slick-prev {
    left: 18px;
  }
  .slick-next {
    right: 18px;
  }
  .slick-list {
    overflow: visible;
  }
  .slick-track {
    > div {
      padding-right: 14px;
    }
  }
`;

export const StyledMethodContainer = styled(Container)<{
  bacgkroundUrl?: boolean;
}>`
  ${({ bacgkroundUrl }) =>
    bacgkroundUrl &&
    `
    background-image: url(${assets["methodBackground"]}); background-position: center;
    background-size: 700px; 
    background-repeat: repeat; 
    background-color: white; 
    `}
`;

export const ExternalButton = styled(Link)`
  border-radius: 21px;
  color: #000;
  font-family: ${DEFAULT_FONT};
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border: 1.5px solid #000;
  padding: 5px 20px;
`;
